"use strict";

import angular from "angular";
import _ from "lodash";

import { Company } from "../../../gateway/Company/Company";
import { Dashboard } from "../../../gateway/Dashboard/Dashboard";
import { DashboardAvailable } from "../../../gateway/DashboardAvailable/DashboardAvailable";
import { Point } from "../../../gateway/Point/Point";
import { PointCalculated } from "../../../gateway/PointCalculated/PointCalculated";
import { Serie } from "../../../gateway/Serie/Serie";
import { User } from "../../../gateway/User/User";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { AccountingContractManager } from "../../../presentation/services/AccountingContractManager/AccountingContractManager";
import { LocalStoreService } from "../../../presentation/services/LocalStoreService";
import { PopulateManager } from "../../../presentation/services/PopulateManager/PopulateManager";
import { AvailablePopulateUsecase } from "../../../usecases/available-populate.usecase";
import { SaveManyUserUsecase } from "../../../usecases/save-many-user.usecase";
import {
    customerUsers,
    nucontersUsers
} from "../../../utils/users-roles/users-roles";

angular
    .module("nucont.accounting.company")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.company", {
        url: "/empresa/:id",
        params: { startTour: { value: null, dynamic: true } },
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting-company" */ "./company.component"
            ).then(() => $ocLazyLoad.inject("nucont.accounting.company"));
        },
        views: {
            "admin@nucont.accounting": {
                component: "companyComponent",
                bindings: { companyData: "CompanyData" }
            }
        },
        data: {
            rolesGuard: [...nucontersUsers, ...customerUsers],
            layoutConfig: {
                model: "LayoutConfigModel5",
                ignore: { object: "headerConfig", path: "title" }
            }
        },
        resolve: {
            CompanyData: [
                "$stateParams",
                "$rootScope",
                "NavigationService",
                "LayoutService",
                "ParameterizationProcessService",
                "CompanyDataService",
                "ParameterizationSidenavService",
                async (
                    $stateParams,
                    $rootScope,
                    NavigationService,
                    LayoutService,
                    ParameterizationProcessService,
                    CompanyDataService,
                    ParameterizationSidenavService
                ) => {
                    $rootScope.accIdReference = $stateParams.accIdReference;
                    const companyId = $stateParams.id;
                    const list = await new Company({}).getByIds([companyId]);
                    const companyData = list?.[0] || {};
                    const localStoreService = new LocalStoreService();
                    localStoreService.setItem("company", {
                        _id: companyData?._id,
                        name: companyData?.name,
                        segment: companyData?.segment?.t,
                        segmentGroup: companyData?.segmentGroup,
                        size: companyData?.size,
                        taxation: companyData?.taxation
                    });
                    $rootScope.company = companyData;
                    $rootScope.withoutParametrization =
                        companyData?.preferences?.withoutParametrization;

                    LayoutService.setAttrs([
                        {
                            object: "headerConfig",
                            path: "title.text",
                            value: companyData.name
                        },
                        {
                            object: "headerConfig",
                            path: "title.enabled",
                            value: true
                        }
                    ]);

                    setTimeout(() => {
                        NavigationService.setParams("id", $stateParams.id);
                        NavigationService.setParams(
                            "accountingId",
                            $stateParams.accountingId
                        );
                        NavigationService.setHref();
                    }, 1000);
                    CompanyDataService.set(companyData);
                    ParameterizationProcessService.init({
                        companyData
                    });
                    ParameterizationSidenavService.setIsPopulate(false);
                    return companyData;
                }
            ],
            AvailablePopulate: [
                "$stateParams",
                "ContractService",
                "AccountingFactory",
                async ($stateParams, ContractService, AccountingFactory) => {
                    new Point().deleteMany({});
                    new PointCalculated().deleteMany({});
                    new PopulateManager().deleteMany({});
                    new Serie().deleteMany({});
                    const availablePopulateUsecase = new AvailablePopulateUsecase();
                    const dashboardAvailable = new DashboardAvailable();
                    const companyId = $stateParams.id;
                    const [available, dashboardsIds] = await Promise.all([
                        availablePopulateUsecase.execute({ companyId }),
                        dashboardAvailable.populate({
                            companyId
                        })
                    ]);

                    try {
                        const hasAccounting = dashboardsIds.filter(
                            (dash) => dash.source == "accounting"
                        );
                        if (!hasAccounting.length) {
                            const dashboardHttpGateway = new Dashboard();
                            await dashboardHttpGateway.copyPublicDashboards({
                                companyId,
                                accounting: AccountingFactory.getDocument()
                            });
                            await dashboardAvailable.populate({
                                companyId
                            });
                        }
                    } catch (error) {
                        console.error(
                            "ERROR AO GERAR DASHBAORD CONTABIL",
                            error
                        );
                    }

                    var fim = performance.now();
                }
            ],
            setTheme: [
                "$stateParams",
                "$state",
                "ThemesService",
                "accountingData",
                "accountingPlanEntity",
                async (
                    $stateParams,
                    $state,
                    ThemesService,
                    accountingData,
                    accountingPlanEntity
                ) => {
                    const user = new UserDataAdapter().user();
                    const UserDomain = new User();

                    if (!accountingData)
                        return $state.go("nucont.accounting.companies", {
                            accountingId:
                                user.profile.accountingId ||
                                $state.params.accIdReference ||
                                $state.params.accountingId ||
                                $stateParams.accIdReference ||
                                $stateParams.accountingId
                        });

                    const hasPermission = new AccountingContractManager({
                        User: UserDomain
                    }).hasPermission({
                        contract: accountingData.contract,
                        user: user,
                        feature: "dashboardThemes",
                        accountingPlanEntity: accountingPlanEntity
                    });

                    if (
                        hasPermission === "expired" &&
                        user.profile.dashboardTheme !== "default"
                    ) {
                        const saveManyUserUsecase = new SaveManyUserUsecase();
                        const userId = new UserDataAdapter().user()._id;
                        saveManyUserUsecase.execute({
                            accountingId: accountingData._id,
                            users: [{ _id: userId, dashboardTheme: "default" }]
                        });
                        ThemesService.setCurrentDashboardTheme("default");
                    } else {
                        ThemesService.setCurrentDashboardTheme(
                            user.profile.dashboardTheme || "default"
                        );
                    }
                }
            ]
        }
    });
}
